import type { BlockHintStyle } from '@gitbook/doc-core';
import { Icon, type SVGIconComponent } from '@gitbook/spine-icons';
/**
 * Styles for hints
 */
export const HINT_STYLES: {
    [key in BlockHintStyle]: {
        title: string;
        icon: SVGIconComponent;
    };
} = {
    info: {
        title: 'Info',
        icon: Icon.InfoCircle,
    },
    warning: {
        title: 'Warning',
        icon: Icon.Warning,
    },
    success: {
        title: 'Success',
        icon: Icon.CheckCircle,
    },
    danger: {
        title: 'Danger',
        icon: Icon.Alert,
    },
};
